/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AccountsComponent } from './pages/accounts/accounts.component';
import { AuthGuard } from '../../core/guards';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { DeepThoughtComponent } from './deep-thought.component';
import { LoadbalancerSharedModule } from '../loadbalancer/shared/loadbalancer.shared.module';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { NoAccessComponent, PageErrorComponent } from '../../core/components';
import { OrganisationsComponent } from './pages/organisations/organisations.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../core/shared.module';

/**
 * Routes associated to the Login Page/Component
 * @type {ModuleWithProviders}
 */
const DeepThoughtRouting: ModuleWithProviders<any> = RouterModule.forChild([
    {
        path: 'dt',
        component: DeepThoughtComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'dashboard',
                component: DashboardComponent
            },
            {
                path: 'organisations',
                component: OrganisationsComponent
            },
            {
                path: 'accounts',
                component: AccountsComponent
            },
            {
                path: 'no-access',
                component: NoAccessComponent
            },
            {
                path: 'page-error',
                component: PageErrorComponent
            },
            {
                path: '**',
                redirectTo: '/404',
            }
        ]
    }
]);

/**
 * Define dependencies
 */
@NgModule({
    imports: [
        DeepThoughtRouting,
        SharedModule,
        LoadbalancerSharedModule,
        // Pages
    ],
    declarations: [
        DeepThoughtComponent,
        DashboardComponent,
        OrganisationsComponent,
        AccountsComponent
    ],
    exports: [],
    providers: []
})

export class DeepThoughtModule {
}
